import { getLocale } from '../../util/Localizer'

// the types of claims. These should align with submitExpenseActions.fetchBenefitTypes API returns as it returns text
// NOTE: the functions are a hack but soap returns ClaimTypes as string but localized :/
export const ClaimTypes = {
  /**
   * checks if the value is a dental type
   *
   * @param {string} value - the value to check
   * @returns {boolean}
   */
  isDental: function (value) {
    return value === ClaimTypes.DENTAL || value === ClaimTypes.DENTAL_FR
  },
  /**
   * checks if the value is a drug type
   *
   * @param {string} value - the value to check
   * @returns {boolean}
   */
  isDrug: function (value) {
    return value === ClaimTypes.DRUG || value === ClaimTypes.DRUG_FR
  },

  /**
   * checks to see if it's a EHC other
   */
  isEHCOther: function (value) {
    return value === ClaimTypes.OTHER_EHC || value === ClaimTypes.OTHER_EHC_FR || value === ClaimTypes.OTHER_EHC_FR_2
  },

  DENTAL: 'Dental',
  DENTAL_FR: 'Soins Dentaires',
  DRUG: 'Drug',
  DRUG_FR: 'Médicaments',
  OTHER_EHC: 'Other Extended Health',
  OTHER_EHC_FR: 'Soins Prolongés',
  OTHER_EHC_FR_2: 'Autre Maladie Complémentaire', // we have this also as EHC other, don't ask (MA)
  UNKNOWN: 'unknown' // this is just what is set as default
}

// to be used for claims that are submited to the server and the response that comes back to check the claim status.
// NOTE: just like above, since the status is localized to the language and not an enum we need todo this hack.
export const ClaimStatus = {

  /**
   * checkes to see if the value is pending or not
   *
   * @param {string} value - the value to check whcih should be a string
   * @returns {boolean} - true if it is pending else false
   */
  isPending: function (value) {
    if (getLocale() === 'en') {
      return value === ClaimStatus.PENDING
    } else {
      return value === ClaimStatus.PENDING_FR
    }
  },

  PENDING: 'Pending',
  PENDING_FR: 'En Attente'
}



// WEBPACK FOOTER //
// ./src/redux/SubmitClaim/Common.js